import storage from "./storage";

export default function useVisitorId() {
    let id = storage.getItem('visitor_id');
    if (id) return id;
    id = btoa(Math.random().toString());
    storage.setItem("visitor_id", id);
    return id;
}

export function useHashVisitorId(id) {
    const hash = id.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
    const group = hash % 10;
    return group;
}